module.exports = __webpack_public_path__ + "media/images/photo11-68a267d2fc3161dad8267ea3a0112c58.png";